import { UsersTypes } from './actionTypes';

const INIT_STATE = {
  users: [],
  usersDetail: {},
  usersAdd: {},
  CountItems: 0,
  deleteId: undefined,
  usersUpdate: {},
  error: {},
  success: '',
  message: '',
  loading: false,
  successUpdate: false,
  loadingUpdate: false,
};

const Users = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    //GET CLIENT
    case UsersTypes.GET_USERS:
      return {
        ...state,
        loading: true,
      };
    case UsersTypes.GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
        CountItems: action?.payload?.CountItems ?? 0,
        usersAdd: {},
        loading: false,
      };
    case UsersTypes.GET_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
        users: [],
        usersAdd: {},
        loading: false,
      };

    case UsersTypes.GET_USERS_DETAIL_SUCCESS:
      return {
        ...state,
        usersDetail: action.payload,
      };

    case UsersTypes.GET_USERS_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UsersTypes.ADD_USERS:
      return {
        ...state,
        loading: true,
      };
    case UsersTypes.ADD_USERS_SUCCESS:
      return {
        ...state,
        usersAdd: action.payload,
      };
    case UsersTypes.ADD_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case UsersTypes.DELETE_USERS:
      return {
        ...state,
        loading: true,
      };
    case UsersTypes.DELETE_USERS_SUCCESS:
      return {
        ...state,
        deleteId: action.payload,
      };
    case UsersTypes.DELETE_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case UsersTypes.UPDATE_USERS:
      return {
        ...state,
        loading: true,
      };

    case UsersTypes.UPDATE_USERS_SUCCESS:
      return {
        ...state,
        success: true,
      };

    case UsersTypes.UPDATE_USERS_FAIL:
      return {
        ...state,
        loading: false,
      };

    case UsersTypes.PASSWORD_REQUEST_UPDATE_USERS:
      return {
        ...state,
        loadingUpdate: true,
      };
    case UsersTypes.PASSWORD_REQUEST_UPDATE_USERS_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        successUpdate: true,
        message: 'Password updated',
      };
    case UsersTypes.PASSWORD_REQUEST_USERS:
      return {
        ...state,
        loading: true,
      };
    case UsersTypes.PASSWORD_REQUEST_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.body.data.SetForgotPasswordToken.message,
        success: action.payload.body.data.SetForgotPasswordToken.success,
      };

    default:
      break;
  }
  return state;
};

export default Users;
